/// <reference path="../../../data/DataModels/types.d.ts" />
import { 
    Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Typography,
    List, ListItem, ListItemText, ListItemSecondaryAction, Paper
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import { CloseIcon } from "@material-ui/data-grid";
import React from "react";
import { StripeAccountStatusCode } from "../../../data/Models/StripeAccountStatusCode";
import { StripeAccountTypeCode } from "../../../data/Models/StripeAccountTypeCode";
import { createOrganization, getOrganization, updateOrganization } from "../../../data/OrganizationRepository";
import { getAccountInfo } from "../../../data/PortalUserRepository";
import { getStates } from "../../../data/StatesRepository";
import { MarkdownEditor } from "../Events/MarkdownEditor";
import { GenericErrorModal } from "../GenericErrorModal";
import { GenericDropdown } from "../SubComponents/GenericDropdown";
import ImageUploading, { ImageListType } from "react-images-uploading";
import ClearIcon from "@material-ui/icons/Clear";
import DeleteIcon from "@material-ui/icons/Delete"; 
import { v4 as uuidv4 } from 'uuid';


var Enumerable = require("linq");

interface ISaveOrganizationPageProps {
    loadingOn: () => void;
    loadingOff: () => void;
    changePage: (page: string) => void;
}

export class SaveOrganizationPage extends React.Component<ISaveOrganizationPageProps> {
    state = {
        organizationId: "",
        states: [],
        stripeAccountTypes: [],
        stripeAccountTypeCode: StripeAccountTypeCode.Company,
        stripeAccountTypeCodeError: "",
        organizationName: "",
        organizationNameError: "",
        bankAccountNumber: "",
        stripeAccountStatus: "",
        stripeAccountStatusCode: StripeAccountStatusCode.Unknown,
        firstName: "",
        firstNameError: "",
        lastName: "",
        lastNameError: "",
        ssn: "",
        ssnError: "",
        email: "",
        emailError: "",
        phone: "",
        phoneError: "",
        birthday: new Date(),
        birthdayError: "",
        businessTaxId: "",
        businessTaxIdError: "",
        addressStreet: "",
        addressStreetError: "",
        addressCity: "",
        addressCityError: "",
        addressState: "",
        addressStateError: "",
        addressPostalCode: "",
        addressPostalCodeError: "",
        supportFieldsSameAsBusinessFields: false,
        supportEmail: "",
        supportEmailError: "",
        supportPhone: "",
        supportPhoneError: "",
        supportAddressStreet: "",
        supportAddressStreetError: "",
        supportAddressCity: "",
        supportAddressCityError: "",
        supportAddressState: "",
        supportAddressStateError: "",
        supportAddressPostalCode: "",
        supportAddressPostalCodeError: "",
        accountNumber: "",
        accountNumberError: "",
        routingNumber: "",
        routingNumberError: "",
        stripeAccountSetupUrl: "",
        stripeAccountUrl: "",
        organizationPublicUrl: "",
        createConfirmModalOpen: false,
        serverError: "",
        taxFormSignatureExpected: "",
        taxFormSignature: "",
        taxFormSignatureError: "",
        taxFormSignedAt: new Date(),
        mastheadImageUrl: "",
        facebookUrl: "",
        facebookUrlError: "",
        twitterUrl: "",
        twitterUrlError: "",
        instagramUrl: "",
        instagramUrlError: "",
        tikTokUrl: "",
        tikTokUrlError: "",
        additionalLinks: [] as { id: string, name: string; url: string }[],
        newLinkName: "",
        newLinkNameError: "",
        newLinkUrl: "",
        newLinkUrlError: "",
        summary: "",
        summaryError: "",
        loading: true,

        uploadFiles: [],
        uploadFilePreviews: [],
        uploadFilesError: "",
        deleteUploadFileIds: [],
    };

    async componentDidMount() {
        this.props.loadingOn();

        let stripeAccountTypes = [
            { id: StripeAccountTypeCode.Individual, name: "Individual" },
            { id: StripeAccountTypeCode.Company, name: "Company" },
        ];

        const query = new URLSearchParams(window.location.search);

        var organizationId: string = query.get("id") ?? "";

        let states = [];
        let serverError = "";

        let response = await getStates();

        let urlParams = "";

        if (organizationId != null && organizationId != "") {
            urlParams = `?id=${organizationId}`;
        }

        if (response != null && response.status == 401) {
            this.props.changePage(`/login?redirect=save-organization${urlParams}`);
        } else if (response != null && response.status == 200) {
            if (!response.data.success) {
                serverError = response.data.errorMsg;
            } else {
                states = Enumerable.from(response.data.states)
                    .select((o: any) => ({
                        id: o.abbreviation,
                        name: o.abbreviation,
                    }))
                    .toArray();
            }
        } else {
            serverError = "An unknown error occured. Please try again later";
        }

        let organizationPublicUrl = process.env.REACT_APP_NRBY_ORG_PUBLICLINK;

        console.log("public url" + organizationPublicUrl);

        if (organizationId != undefined && organizationId != "") {
            let stripeAccountTypeCode = StripeAccountTypeCode.Individual;
            let name = "";
            let bankAccountNumber = "";
            let bankRoutingNumber = "";
            let firstName = "";
            let lastName = "";
            let email = "";
            let phone = "";
            let birthday = new Date();
            let streetAddress = "";
            let city = "";
            let state = "";
            let postalCode = "";
            let supportEmail = "";
            let supportPhone = "";
            let supportStreetAddress = "";
            let supportCity = "";
            let supportState = "";
            let supportPostalCode = "";
            let stripeAccountSetupUrl = "";
            let stripeAccountUrl = "";
            let ssn = "";
            let additionalLinks: any[] = [];
            let mastheadImageUrl = "";
            let facebookUrl = "";
            let twitterUrl = "";
            let instagramUrl = "";
            let tikTokUrl = "";
            let summary = "";

            var organizationResponse = await getOrganization(organizationId);

            if (organizationResponse != null && organizationResponse.status == 401) {
                this.props.changePage(`/login?redirect=save-organization${urlParams}`);
            } else if (organizationResponse != null && organizationResponse.status == 200) {
                if (!organizationResponse.data.success) {
                    serverError = organizationResponse.data.errorMsg;
                } else {
                    stripeAccountTypeCode = organizationResponse.data.organization.stripeAccountTypeCode;
                    name = organizationResponse.data.organization.name;
                    bankAccountNumber = "***" + organizationResponse.data.organization.bankAccountNumber;
                    bankRoutingNumber = organizationResponse.data.organization.bankRoutingNumber;
                    firstName = organizationResponse.data.organization.firstName;
                    lastName = organizationResponse.data.organization.lastName;
                    ssn = organizationResponse.data.organization.ssn;
                    email = organizationResponse.data.organization.email;
                    phone = organizationResponse.data.organization.phone;
                    birthday = new Date(organizationResponse.data.organization.birthday);
                    streetAddress = organizationResponse.data.organization.streetAddress;
                    city = organizationResponse.data.organization.city;
                    state = organizationResponse.data.organization.state;
                    postalCode = organizationResponse.data.organization.postalCode;

                    supportEmail = organizationResponse.data.organization.supportEmail;
                    supportPhone = organizationResponse.data.organization.supportPhone;
                    supportStreetAddress = organizationResponse.data.organization.supportStreetAddress;
                    supportCity = organizationResponse.data.organization.supportCity;
                    supportState = organizationResponse.data.organization.supportState;
                    supportPostalCode = organizationResponse.data.organization.supportPostalCode;
                    stripeAccountSetupUrl = organizationResponse.data.organization.stripeAccountSetupUrl;
                    stripeAccountUrl = organizationResponse.data.organization.stripeAccountUrl;

                    organizationPublicUrl = organizationPublicUrl != undefined ? organizationPublicUrl.replace("{id}", organizationId) : "";

                    mastheadImageUrl = organizationResponse.data.organization.mastheadImageUrl;
                    facebookUrl = organizationResponse.data.organization.facebookUrl ?? "";
                    twitterUrl = organizationResponse.data.organization.twitterUrl ?? "";
                    instagramUrl = organizationResponse.data.organization.instagramUrl ?? "";
                    tikTokUrl = organizationResponse.data.organization.tikTokUrl ?? "";
                    additionalLinks = organizationResponse.data.organization.additionalLinks ?? [];
                    summary = organizationResponse.data.organization.summary;
                    
                    console.log("public url" + organizationPublicUrl);
                }
            } else {
                serverError = "An unknown error occured. Please try again later";
            }

            this.setState({
                ...this.state,
                organizationId: organizationId,
                stripeAccountTypeCode: stripeAccountTypeCode,
                organizationName: name,
                accountNumber: bankAccountNumber,
                routingNumber: bankRoutingNumber,
                firstName: firstName,
                lastName: lastName,
                ssn: ssn,
                email: email,
                phone: phone,
                birthday: birthday,
                addressStreet: streetAddress,
                addressCity: city,
                addressState: state,
                addressPostalCode: postalCode,
                supportEmail: supportEmail,
                supportPhone: supportPhone,
                supportAddressStreet: supportStreetAddress,
                supportAddressCity: supportCity,
                supportAddressState: supportState,
                supportAddressPostalCode: supportPostalCode,
                stripeAccountTypes: stripeAccountTypes,
                states: states,
                organizationPublicUrl: organizationPublicUrl,
                stripeAccountSetupUrl: stripeAccountSetupUrl,
                stripeAccountUrl: stripeAccountUrl,

                mastheadImageUrl: mastheadImageUrl,
                facebookUrl: facebookUrl,
                twitterUrl: twitterUrl,
                instagramUrl: instagramUrl,
                tikTokUrl: tikTokUrl,
                additionalLinks: additionalLinks,
                summary: summary,

                serverError: serverError,
                loading: false,
            });
        } else {
            this.setState({
                ...this.state,
                stripeAccountTypes: stripeAccountTypes,
                states: states,
                organizationPublicUrl: organizationPublicUrl,
                serverError: serverError,
                loading: false,
            });
        }

        this.props.loadingOff();
    }

    HandleOrganizationNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, organizationName: event.currentTarget.value });
    };

    HandleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, firstName: event.currentTarget.value });
    };

    HandleLastNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, lastName: event.currentTarget.value });
    };

    HandleSsnChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, ssn: event.currentTarget.value });
    };

    HandleEmailChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, email: event.currentTarget.value });
    };

    HandlePhoneChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, phone: event.currentTarget.value });
    };

    HandleBirthdayChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, birthday: event.currentTarget.value });
    };

    HandleBusinessTaxIdChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, businessTaxId: event.currentTarget.value });
    };

    HandleAddressStreetChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, addressStreet: event.currentTarget.value });
    };

    HandleAddressCityChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, addressCity: event.currentTarget.value });
    };

    HandleAddressStateChange = (value: any) => {
        this.setState({ ...this.state, addressState: value });
    };

    HandleAddressPostalCodeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, addressPostalCode: event.currentTarget.value });
    };

    HandleSupportEmailChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, supportEmail: event.currentTarget.value });
    };

    HandleSupportPhoneChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, supportPhone: event.currentTarget.value });
    };

    HandleSupportAddressStreetChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, supportAddressStreet: event.currentTarget.value });
    };

    HandleSupportAddressCityChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, supportAddressCity: event.currentTarget.value });
    };

    HandleSupportAddressStateChange = (value: any) => {
        this.setState({ ...this.state, supportAddressState: value });
    };

    HandleSupportAddressPostalCodeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, supportAddressPostalCode: event.currentTarget.value });
    };

    HandleAccountNumberChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, accountNumber: event.currentTarget.value });
    };

    HandleFocusAccountNumber = () => {
        if (this.state.accountNumber.indexOf("...") >= 0) this.setState({ ...this.state, accountNumber: "" });
    };

    HandleRoutingNumberChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, routingNumber: event.currentTarget.value });
    };

    IsNullOrWhiteSpace = (str: string) => {
        return !(str && str.trim());
    };

    HandleTaxFormSignatureChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.currentTarget.value != this.state.taxFormSignatureExpected) {
            let taxFormSignatureError = "Wrong signature";
            this.setState({
                ...this.state,
                taxFormSignature: event.currentTarget.value,
                taxFormSignatureError: taxFormSignatureError,
            });
            return;
        }

        this.setState({
            ...this.state,
            taxFormSignature: event.currentTarget.value,
            taxFormSignatureError: "",
        });
    };

    HandleNewLinkNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        // Clear error when user starts typing
        this.setState({ ...this.state, newLinkName: event.currentTarget.value, newLinkNameError: "" });
    };

    HandleNewLinkUrlChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, newLinkUrl: event.currentTarget.value, newLinkUrlError: "" });
    };

    HandleAddLink = () => {
        const nameInput = this.state.newLinkName.trim();
        let urlInput = this.state.newLinkUrl.trim();

        let hasError = false;

        // Validate name
        if (!nameInput) {
            this.setState({ ...this.state, newLinkNameError: "Link name is required" });
            hasError = true;
        }

        // Validate URL
        if (!urlInput) {
            this.setState((prev) => ({ ...prev, newLinkUrlError: "URL is required" }));
            hasError = true;
        }

        if (hasError) return;

        // Normalize URL
        if (!/^https?:\/\//i.test(urlInput)) {
            urlInput = 'https://' + urlInput;
        }

        // Validate URL format
        let isValid = false;
        try {
            const parsedUrl = new URL(urlInput);
            isValid = ['http:', 'https:'].includes(parsedUrl.protocol) && !!parsedUrl.hostname && parsedUrl.hostname.includes('.');
        } catch (_) {
            isValid = false;
        }

        if (!isValid) {
            this.setState({ ...this.state, newLinkUrlError: "Please enter a valid URL (e.g., example.com)" });
            return;
        }

        const newLink = {
            id: uuidv4(),
            name: nameInput,
            url: urlInput
        };

        this.setState({
            ...this.state,
            additionalLinks: [...this.state.additionalLinks, newLink],
            newLinkName: "",
            newLinkNameError: "",
            newLinkUrl: "",
            newLinkUrlError: "",
            pendingChanges: true
        });
    };

    HandleRemoveLink = (index: number) => {
        const updatedLinks = [...this.state.additionalLinks];
        updatedLinks.splice(index, 1);
        this.setState({
            ...this.state,
            additionalLinks: updatedLinks,
            pendingChanges: true
        });
    };

    HandleSaveOrganization = async () => {
        this.props.loadingOn();
        let serverError = "";

        let organizationNameError = "";
        let firstNameError = "";
        let lastNameError = "";
        let ssnError = "";
        let addressStreetError = "";
        let addressCityError = "";
        let addressStateError = "";
        let addressPostalCodeError = "";

        let emailError = "";
        let phoneError = "";
        let birthDayError = "";
        let businessTaxIdError = "";
        let accountNumberError = "";
        let routingNumberError = "";
        let errored = false;

        let supportEmailError = "";
        let supportPhoneError = "";

        let supportAddressStreetError = "";
        let supportAddressCityError = "";
        let supportAddressStateError = "";
        let supportAddressPostalCodeError = "";

        let taxFormSignature = this.state.taxFormSignature;

        let taxFormSignatureError = "";

        if (this.state.organizationName == undefined || this.state.organizationName.length == 0) {
            organizationNameError = "Organization Name required.";
            errored = true;
        }

        if (this.state.organizationId == undefined || this.state.organizationId.length == 0) {
            if (this.state.email == undefined || this.state.email.length == 0) {
                emailError = "Email required.";
                errored = true;
            }

            if (this.state.phone == undefined || this.state.phone.length == 0) {
                phoneError = "Phone number required.";
                errored = true;
            }

            if (this.state.addressStreet == undefined || this.state.addressStreet.length == 0) {
                addressStreetError = "Street Address required.";
                errored = true;
            }

            if (this.state.addressCity == undefined || this.state.addressCity.length == 0) {
                addressCityError = "City required.";
                errored = true;
            }

            if (this.state.addressState == undefined || this.state.addressState.length == 0) {
                addressStateError = "State required.";
                errored = true;
            }

            if (this.state.addressPostalCode == undefined || this.state.addressPostalCode.length == 0) {
                addressPostalCodeError = "Zip code required.";
                errored = true;
            }

            if (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual) {
                if (this.state.firstName == undefined || this.state.lastName.length == 0) {
                    firstNameError = "First Name required.";
                    errored = true;
                }

                if (this.state.lastName == undefined || this.state.lastName.length == 0) {
                    lastNameError = "Last Name required.";
                    errored = true;
                }

                if (this.state.ssn == undefined || this.state.ssn.length == 0) {
                    ssnError = "SSN required.";
                    errored = true;
                }

                var todaysDate = new Date();
                var todaysDay = todaysDate.getDate();
                var todaysMonth = todaysDate.getMonth();
                var todaysYear = todaysDate.getFullYear();

                var birthday = new Date(this.state.birthday);

                if (
                    this.state.birthday == undefined ||
                    (birthday.getDate() == todaysDay && birthday.getMonth() == todaysMonth && birthday.getFullYear() == todaysYear)
                ) {
                    birthDayError = "Invalid Date of Birth.";
                    errored = true;
                }
            }

            if (taxFormSignature != this.state.taxFormSignatureExpected) {
                taxFormSignatureError = "Wrong signature";
                errored = true;
            }

            // let fullName = this.state.firstName + " " + this.state.lastName;
            // if (this.state.taxFormSignature != fullName) {
            //     taxFormSignatureError = "Wrong signature";
            //     errored = true;
            // }

            if (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company) {
                if (this.state.businessTaxId == undefined || this.state.businessTaxId.length == 0) {
                    businessTaxIdError = "Tax Id required";
                    errored = true;
                }
            }

            if (this.state.accountNumber == undefined || this.state.accountNumber.length == 0) {
                accountNumberError = "Account Number required.";
                errored = true;
            }

            if (this.state.routingNumber == undefined || this.state.routingNumber.length == 0) {
                routingNumberError = "Routing Number required.";
                errored = true;
            }
        }

        if (this.state.stripeAccountTypeCode != StripeAccountTypeCode.None) {
            if (this.state.supportEmail == undefined || this.state.supportEmail.length == 0) {
                supportEmailError = "Support Email required.";
                errored = true;
            }

            if (this.state.supportPhone == undefined || this.state.supportPhone.length == 0) {
                supportPhoneError = "Support Phone number required.";
                errored = true;
            }

            if (this.state.supportAddressStreet == undefined || this.state.supportAddressStreet.length == 0) {
                supportAddressStreetError = "Support Street Address required.";
                errored = true;
            }

            if (this.state.supportAddressCity == undefined || this.state.supportAddressCity.length == 0) {
                supportAddressCityError = "Support City required.";
                errored = true;
            }

            if (this.state.supportAddressState == undefined || this.state.supportAddressState.length == 0) {
                supportAddressStateError = "Support State required.";
                errored = true;
            }

            if (this.state.supportAddressPostalCode == undefined || this.state.supportAddressPostalCode.length == 0) {
                supportAddressPostalCodeError = "Support Zip code required.";
                errored = true;
            }
        }

        if (errored == false) {
            let supportAddress: IStripeAccountAddress = {
                streetAddress: this.state.supportAddressStreet,
                city: this.state.supportAddressCity,
                state: this.state.supportAddressState,
                postalCode: this.state.supportAddressPostalCode,
            };

            let address: IStripeAccountAddress = {
                streetAddress: this.state.addressStreet,
                city: this.state.addressCity,
                state: this.state.addressState,
                postalCode: this.state.addressPostalCode,
            };

            if (this.state.organizationId == null || this.state.organizationId == "") {
                serverError = await this.CreateOrganization(address, supportAddress);
            } else {
                serverError = await this.UpdateOrganization(this.state.organizationId, supportAddress, address);
            }
        } else {
            taxFormSignature = "";
        }

        this.setState({
            ...this.state,
            organizationNameError: organizationNameError,
            firstNameError: firstNameError,
            lastNameError: lastNameError,
            emailError: emailError,
            phoneError: phoneError,
            birthdayError: birthDayError,
            businessTaxIdError: businessTaxIdError,
            ssnError: ssnError,
            addressStreetError: addressStreetError,
            addressCityError: addressCityError,
            addressStateError: addressStateError,
            addressPostalCodeError: addressPostalCodeError,
            supportEmailError: supportEmailError,
            supportPhoneError: supportPhoneError,
            supportAddressStreetError: supportAddressStreetError,
            supportAddressCityError: supportAddressCityError,
            supportAddressStateError: supportAddressStateError,
            supportAddressPostalCodeError: supportAddressPostalCodeError,
            accountNumberError: accountNumberError,
            routingNumberError: routingNumberError,
            createConfirmModalOpen: taxFormSignatureError != "",
            taxFormSignature: taxFormSignature,
            taxFormSignatureError: taxFormSignatureError,
            serverError: serverError,
        });
        this.props.loadingOff();
    };

    CreateOrganization = async (address: IStripeAccountAddress, supportAddress: IStripeAccountAddress) => {
        let serverError = "";

        let request: ICreateOrganization = {
            stripeAccountTypeCode: this.state.stripeAccountTypeCode,
            organizationName: this.state.organizationName,
            firstName: this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual ? this.state.firstName : undefined,
            lastName: this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual ? this.state.lastName : undefined,
            ssn: this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual ? this.state.ssn : undefined,
            email: this.state.email,
            phone: this.state.phone,
            birthDay: this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual ? this.state.birthday : undefined,
            businessTaxId: this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company ? this.state.businessTaxId : undefined,
            address: address,
            supportEmail: this.state.supportEmail,
            supportPhone: this.state.supportPhone,
            supportAddress: supportAddress,
            accountNumber: this.state.accountNumber,
            routingNumber: this.state.routingNumber,
            taxFormSignature: this.state.taxFormSignature,
            taxFormSignedAt: this.state.taxFormSignedAt,
            mastheadImageUrl: this.state.mastheadImageUrl,
            facebookUrl: this.state.facebookUrl,
            twitterUrl: this.state.twitterUrl,
            instagramUrl: this.state.instagramUrl,
            tikTokUrl: this.state.tikTokUrl,
            additionalLinks: JSON.stringify(this.state.additionalLinks),
            summary: this.state.summary,
            masthead: this.state.uploadFiles.length>0 ? (this.state.uploadFiles[0] as any).file : undefined,
        };

        var response = await createOrganization(request);

        if (response != null && response.status == 200) {
            if (!response.data.success) {
                serverError = response.data.errorMsg;
            } else {
                await this.props.changePage("/organizations");
            }
        } else {
            serverError = "An unknown error occured. Please try again later";
        }

        return serverError;
    };

    UpdateOrganization = async (organizationId: string, supportAddress: IStripeAccountAddress, address: IStripeAccountAddress) => {
        let serverError = "";

        let request: IUpdateOrganization = {
            organizationId: organizationId,
            organizationName: this.state.organizationName,
            email: this.state.email,
            phone: this.state.phone,
            address: address,
            supportEmail: this.state.supportEmail,
            supportPhone: this.state.supportPhone,
            supportAddress: supportAddress,
            mastheadImageUrl: this.state.mastheadImageUrl,
            facebookUrl: this.state.facebookUrl,
            twitterUrl: this.state.twitterUrl,
            instagramUrl: this.state.instagramUrl,
            tikTokUrl: this.state.tikTokUrl,
            additionalLinks: JSON.stringify(this.state.additionalLinks) as any,
            summary: this.state.summary,
            masthead: this.state.uploadFiles.length>0 ? (this.state.uploadFiles[0] as any).file : undefined,
        };

        var response = await updateOrganization(request);

        if (response != null && response.status == 200) {
            if (!response.data.success) {
                serverError = response.data.errorMsg;
            } else {
                await this.props.changePage("/organizations");
            }
        } else {
            serverError = "An unknown error occured. Please try again later";
        }

        return serverError;
    };

    OnAccountTypeChange = async (value: any) => {
        if (this.state.organizationId == null || this.state.organizationId == "") {
            var firstName = "";
            var lastName = "";
            var serverError = "";

            if (value == StripeAccountTypeCode.Company) {
                firstName = "";
                lastName = "";
            } else {
                var result = await this.GetAccountInfoFullName();

                serverError = result.serverError;

                if (serverError == null || serverError == "") {
                    firstName = result.firstName;
                    lastName = result.lastName;
                }
            }

            this.setState({
                ...this.state,
                stripeAccountTypeCode: value,
                firstName: firstName,
                lastName: lastName,
                serverError: serverError,
            });
        } else {
            this.setState({ ...this.state, stripeAccountTypeCode: value });
        }
    };

    CloseErrorModal = () => {
        this.setState({ ...this.state, serverError: "" });
    };

    OpenCreateConfirmModal = async () => {
        var serverError = "";
        var taxFormSignatureExpected = "";

        if (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company) {
            var result = await this.GetAccountInfoFullName();
            serverError = result.serverError;

            if (serverError == null || serverError == "") {
                taxFormSignatureExpected = result.firstName + " " + result.lastName;
            }
        } else {
            taxFormSignatureExpected = this.state.firstName + " " + this.state.lastName;
        }

        this.setState({
            ...this.state,
            createConfirmModalOpen: true,
            taxFormSignatureExpected: taxFormSignatureExpected,
            serverError: serverError,
        });
    };

    GetAccountInfoFullName = async () => {
        var accountInfoResponse = await getAccountInfo();

        var firstName = "";
        var lastName = "";
        var serverError = "";

        let urlParams = "";

        if (this.state.organizationId != null && this.state.organizationId != "") {
            urlParams = `?id=${this.state.organizationId}`;
        }

        if (accountInfoResponse != null && accountInfoResponse.status == 401) {
            this.props.changePage(`/login?redirect=save-organization${urlParams}`);
        } else if (accountInfoResponse != null && accountInfoResponse.status == 200) {
            if (!accountInfoResponse.data.success) {
                serverError = accountInfoResponse.data.errorMsg;
            } else {
                firstName = accountInfoResponse.data.firstName;
                lastName = accountInfoResponse.data.lastName;
            }
        } else {
            serverError = "An unknown error occured. Please try again later";
        }

        return {
            firstName: firstName,
            lastName: lastName,
            serverError: serverError,
        };
    };

    CloseCreateModal = () => {
        this.setState({
            ...this.state,
            createConfirmModalOpen: false,
            taxFormSignatureExpected: "",
        });
    };

    HandleCopyBusinessFieldsClick = () => {
        if (!this.state.supportFieldsSameAsBusinessFields) {
            this.setState({
                ...this.state,
                supportFieldsSameAsBusinessFields: !this.state.supportFieldsSameAsBusinessFields,
                supportEmail: this.state.email,
                supportPhone: this.state.phone,
                supportAddressStreet: this.state.addressStreet,
                supportAddressCity: this.state.addressCity,
                supportAddressState: this.state.addressState,
                supportAddressPostalCode: this.state.addressPostalCode,
            });
        } else {
            this.setState({
                ...this.state,
                supportFieldsSameAsBusinessFields: !this.state.supportFieldsSameAsBusinessFields,
                supportEmail: "",
                supportPhone: "",
                supportAddressStreet: "",
                supportAddressCity: "",
                supportAddressState: "",
                supportAddressPostalCode: "",
            });
        }
    };

    HandleSummaryChange = async (value: any) => {
        this.setState({ ...this.state, summary: value });
    };

    HandleFacebookUrlChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, facebookUrl: event.currentTarget.value });
    };

    HandleTwitterUrlChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, twitterUrl: event.currentTarget.value });
    };

    HandleInstagramUrlChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, instagramUrl: event.currentTarget.value });
    };

    HandleTikTokUrlChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.setState({ ...this.state, tikTokUrl: event.currentTarget.value });
    };

    OnAddFiles = (value: ImageListType) => {
        const afterStateChange = () => {
            value.forEach((image: any) => {
                const reader = new FileReader();

                reader.onloadend = (ev: any) => {
                    this.AddUploadFilePreview(image.file, ev.target.result);
                };

                reader.readAsDataURL(image.file);
            });
        };

        this.AddUploadFiles(value, afterStateChange);
    };

    AddUploadFilePreview = (file: any, contentDisposition: string) => {
        //this.props.handleChangesPendingChange(true);
        this.setState({
            ...this.state,
            uploadFilePreviews: { ...this.state.uploadFilePreviews, [file.uid]: contentDisposition },
            pendingChanges: true,
        });
    };

    AddUploadFiles = (files: ImageListType, callback?: () => void) => {
        //this.props.handleChangesPendingChange(true);
        this.setState({ ...this.state, uploadFiles: files, pendingChanges: true }, callback);
    };

    GetImageFileSize = (sizeBytes: number) => {
        var size = "";

        if (sizeBytes < 1000 * 1000) {
            size = (sizeBytes / 1000).toFixed(3).toString() + " kb";
        } else {
            size = (sizeBytes / (1000 * 1000)).toFixed(3).toString() + " mb";
        }

        return size;
    };

    RemoveSavedFile = () => {
        this.setState({
            ...this.state,
            mastheadImageUrl: '',
            pendingChanges: true,
        });
    };

    render() {
        var createOrganization = this.state.organizationId == null || this.state.organizationId == "";
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div style={{ height: "100%" }}>
                    <Card
                        style={{
                            backgroundColor: "#ededed",
                            marginTop: "10px",
                        }}
                    >
                        <div style={{ paddingTop: "10px" }}>
                            <CardHeader title={createOrganization ? "Create Organization" : "Edit Organization"} />
                        </div>
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        color: "red",
                                        marginBottom: "5px",
                                    }}
                                >
                                    {this.state.stripeAccountUrl != null && this.state.stripeAccountUrl != "" && (
                                        <span>
                                            <strong>
                                                To edit your banking information please login into Stripe using the following link:
                                            </strong>
                                            <br />
                                            <a href={this.state.stripeAccountUrl}>{this.state.stripeAccountUrl}</a>
                                        </span>
                                    )}
                                    {(this.state.stripeAccountUrl == null || this.state.stripeAccountUrl == "") &&
                                        this.state.stripeAccountSetupUrl != null &&
                                        this.state.stripeAccountSetupUrl != "" && (
                                            <span>
                                                <strong>Finish setting up your Stripe account here so you activate your account: </strong>
                                                <br />
                                                <a href={this.state.stripeAccountSetupUrl}>{this.state.stripeAccountSetupUrl}</a>
                                            </span>
                                        )}
                                </Grid>
                                <Grid item xs={12}>
                                    <p style={{ marginTop: "0" }}>
                                        <strong>
                                            Many of the fields below are used on for the generation of a 1099K form. 1099K details include
                                            First Name, Last Name, Tax Id (SSN or ITIN), Street Address, City, State, and Zip Code.
                                        </strong>
                                    </p>
                                </Grid>
                                <Grid item xs={12}>
                                    {this.state.stripeAccountTypeCode != StripeAccountTypeCode.None && (
                                        <GenericDropdown
                                            label="Account Type (Can not be updated once saved)"
                                            value={this.state.stripeAccountTypeCode}
                                            error={this.state.stripeAccountTypeCodeError}
                                            data={this.state.stripeAccountTypes}
                                            onChange={this.OnAccountTypeChange}
                                            disabled={createOrganization == false}
                                        />
                                    )}
                                    {this.state.stripeAccountTypeCode == StripeAccountTypeCode.None && (
                                        <TextField
                                            error={this.state.emailError !== ""}
                                            fullWidth
                                            type="text"
                                            label="Account Type (Can not be updated once saved)"
                                            placeholder="Account type"
                                            margin="normal"
                                            FormHelperTextProps={{
                                                color: "red",
                                            }}
                                            value="Default "
                                            variant="outlined"
                                            disabled={true}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        error={this.state.organizationNameError !== ""}
                                        fullWidth
                                        id="organizationName"
                                        type="text"
                                        label="Organization Name (Stripe Required)"
                                        placeholder="Organization Name (Stripe Required)"
                                        margin="normal"
                                        helperText={this.state.organizationNameError}
                                        FormHelperTextProps={{ color: "red" }}
                                        value={this.state.organizationName}
                                        onChange={(e) => this.HandleOrganizationNameChange(e)}
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        error={this.state.emailError !== ""}
                                        fullWidth
                                        id="email"
                                        type="text"
                                        label="Email"
                                        placeholder="Email"
                                        margin="normal"
                                        helperText={this.state.emailError}
                                        FormHelperTextProps={{ color: "red" }}
                                        value={this.state.email}
                                        onChange={(e) => this.HandleEmailChange(e)}
                                        variant="outlined"
                                        disabled={
                                            createOrganization == false &&
                                            (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company ||
                                                this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual)
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        error={this.state.phoneError !== ""}
                                        fullWidth
                                        id="phone"
                                        type="text"
                                        label="Phone"
                                        placeholder="Phone"
                                        margin="normal"
                                        helperText={this.state.phoneError}
                                        FormHelperTextProps={{ color: "red" }}
                                        value={this.state.phone}
                                        onChange={(e) => this.HandlePhoneChange(e)}
                                        variant="outlined"
                                        disabled={
                                            createOrganization == false &&
                                            (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company ||
                                                this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual)
                                        }
                                    />
                                </Grid>
                                {this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual && (
                                    <React.Fragment>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.firstNameError !== ""}
                                                fullWidth
                                                id="firstName"
                                                type="text"
                                                label="First Name"
                                                placeholder="First Name"
                                                margin="normal"
                                                helperText={this.state.firstNameError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.firstName}
                                                onChange={(e) => this.HandleFirstNameChange(e)}
                                                variant="outlined"
                                                disabled={createOrganization == false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.lastNameError !== ""}
                                                fullWidth
                                                id="lastName"
                                                type="text"
                                                label="Last Name"
                                                placeholder="Last Name"
                                                margin="normal"
                                                helperText={this.state.lastNameError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.lastName}
                                                onChange={(e) => this.HandleLastNameChange(e)}
                                                variant="outlined"
                                                disabled={createOrganization == false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.ssnError !== ""}
                                                fullWidth
                                                id="ssn"
                                                type="text"
                                                label="Social Security Number (###-##-#### or 9 digits)"
                                                placeholder="SSN"
                                                margin="normal"
                                                helperText={this.state.ssnError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.ssn}
                                                onChange={(e) => this.HandleSsnChange(e)}
                                                variant="outlined"
                                                disabled={createOrganization == false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.birthdayError !== ""}
                                                fullWidth
                                                id="birthday"
                                                type="date"
                                                label="Birthday"
                                                placeholder="Birthday"
                                                margin="normal"
                                                helperText={this.state.birthdayError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.birthday}
                                                onChange={(e) => this.HandleBirthdayChange(e)}
                                                variant="outlined"
                                                disabled={createOrganization == false}
                                            />
                                        </Grid>
                                    </React.Fragment>
                                )}
                                {this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company && (
                                    <Grid item xs={12}>
                                        {createOrganization && (
                                            <TextField
                                                error={this.state.businessTaxIdError !== ""}
                                                fullWidth
                                                id="businessTaxId"
                                                type="text"
                                                label="Tax Id (can be either your SSN or ITIN)"
                                                placeholder="Tax Id"
                                                margin="normal"
                                                helperText={this.state.businessTaxIdError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.businessTaxId}
                                                onChange={(e) => this.HandleBusinessTaxIdChange(e)}
                                                variant="outlined"
                                            />
                                        )}
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <TextField
                                        error={this.state.addressStreetError !== ""}
                                        fullWidth
                                        id="addressStreet"
                                        type="text"
                                        label="Street Address"
                                        placeholder="Street Address"
                                        margin="normal"
                                        helperText={this.state.addressStreetError}
                                        FormHelperTextProps={{ color: "red" }}
                                        value={this.state.addressStreet}
                                        onChange={(e) => this.HandleAddressStreetChange(e)}
                                        variant="outlined"
                                        disabled={
                                            createOrganization == false &&
                                            (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company ||
                                                this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual)
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        error={this.state.addressCityError !== ""}
                                        fullWidth
                                        id="addressCity"
                                        type="text"
                                        label="City"
                                        placeholder="City"
                                        margin="normal"
                                        helperText={this.state.addressCityError}
                                        FormHelperTextProps={{ color: "red" }}
                                        value={this.state.addressCity}
                                        onChange={(e) => this.HandleAddressCityChange(e)}
                                        variant="outlined"
                                        disabled={
                                            createOrganization == false &&
                                            (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company ||
                                                this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual)
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <GenericDropdown
                                        label="State"
                                        value={this.state.addressState}
                                        error={this.state.addressStateError}
                                        data={this.state.states}
                                        onChange={this.HandleAddressStateChange}
                                        disabled={
                                            createOrganization == false &&
                                            (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company ||
                                                this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual)
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <TextField
                                        error={this.state.addressPostalCodeError !== ""}
                                        fullWidth
                                        id="addressPostalCode"
                                        type="text"
                                        label="Zip code"
                                        placeholder="Zip code"
                                        margin="normal"
                                        helperText={this.state.addressPostalCodeError}
                                        FormHelperTextProps={{ color: "red" }}
                                        value={this.state.addressPostalCode}
                                        onChange={(e) => this.HandleAddressPostalCodeChange(e)}
                                        variant="outlined"
                                        disabled={
                                            createOrganization == false &&
                                            (this.state.stripeAccountTypeCode == StripeAccountTypeCode.Company ||
                                                this.state.stripeAccountTypeCode == StripeAccountTypeCode.Individual)
                                        }
                                    />
                                </Grid>

                                {this.state.stripeAccountTypeCode != StripeAccountTypeCode.None && (
                                    <React.Fragment>
                                        <Grid item xs={12}>
                                            <div style={{ color: "red" }}>
                                                <strong>
                                                    Note: All support fields are visible for the purpose of business verification for
                                                    Stripe's 3rd party payment system.
                                                </strong>
                                            </div>
                                            {createOrganization && (
                                                <span>
                                                    Once saved, these details will be visible at url format:
                                                    {this.state.organizationPublicUrl}. "id" will be visible once saved.
                                                </span>
                                            )}
                                            {createOrganization == false && (
                                                <span>
                                                    These details are visible at
                                                    <a href={this.state.organizationPublicUrl}>{this.state.organizationPublicUrl}</a>.
                                                </span>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={<Checkbox onChange={this.HandleCopyBusinessFieldsClick} />}
                                                label="Support Email, Phone, and Address are the same as above"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.supportEmailError !== ""}
                                                fullWidth
                                                id="email"
                                                type="text"
                                                label="Support Email (Stripe Required)"
                                                placeholder="Support Email (Stripe Required)"
                                                margin="normal"
                                                helperText={this.state.supportEmailError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.supportEmail}
                                                onChange={(e) => this.HandleSupportEmailChange(e)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.supportPhoneError !== ""}
                                                fullWidth
                                                id="supportPhone"
                                                type="text"
                                                label="Support Phone (Stripe Required)"
                                                placeholder="Support Phone(Stripe Required)"
                                                margin="normal"
                                                helperText={this.state.supportPhoneError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.supportPhone}
                                                onChange={(e) => this.HandleSupportPhoneChange(e)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                error={this.state.supportAddressStreetError !== ""}
                                                fullWidth
                                                id="supportAddressStreet"
                                                type="text"
                                                label="Support Street Address (Stripe Required)"
                                                placeholder="Support Street Address (Stripe Required)"
                                                margin="normal"
                                                helperText={this.state.supportAddressStreetError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.supportAddressStreet}
                                                onChange={(e) => this.HandleSupportAddressStreetChange(e)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.supportAddressCityError !== ""}
                                                fullWidth
                                                id="supportAddressCity"
                                                type="text"
                                                label="Support City (Stripe Required)"
                                                placeholder="Support City (Stripe Required)"
                                                margin="normal"
                                                helperText={this.state.supportAddressCityError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.supportAddressCity}
                                                onChange={(e) => this.HandleSupportAddressCityChange(e)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <GenericDropdown
                                                label="Support State (Stripe Required)"
                                                value={this.state.supportAddressState}
                                                error={this.state.supportAddressStateError}
                                                data={this.state.states}
                                                onChange={this.HandleSupportAddressStateChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                error={this.state.supportAddressPostalCodeError !== ""}
                                                fullWidth
                                                id="supportAddressPostalCode"
                                                type="text"
                                                label="Support Zip code  (Stripe Required)"
                                                placeholder="Support Zip code  (Stripe Required)"
                                                margin="normal"
                                                helperText={this.state.supportAddressPostalCodeError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.supportAddressPostalCode}
                                                onChange={(e) => this.HandleSupportAddressPostalCodeChange(e)}
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.accountNumberError !== ""}
                                                fullWidth
                                                id="accountNumber"
                                                type="text"
                                                label="Account Number"
                                                placeholder="Account Number"
                                                margin="normal"
                                                helperText={this.state.accountNumberError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.accountNumber}
                                                onChange={(e) => this.HandleAccountNumberChange(e)}
                                                onFocus={() => this.HandleFocusAccountNumber()}
                                                variant="outlined"
                                                disabled={createOrganization == false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                error={this.state.routingNumberError !== ""}
                                                fullWidth
                                                id="routingNumber"
                                                type="text"
                                                label="Routing Number"
                                                placeholder="Routing Number"
                                                margin="normal"
                                                helperText={this.state.routingNumberError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.routingNumber}
                                                onChange={(e) => this.HandleRoutingNumberChange(e)}
                                                variant="outlined"
                                                disabled={createOrganization == false}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <h2>Public information</h2>
                                        </Grid>
                                        <Grid item sm={6}>
                                            <TextField
                                                error={this.state.facebookUrlError !== ""}
                                                fullWidth
                                                id="facebookUrl"
                                                type="text"
                                                label="Facebook"
                                                placeholder="Facebook"
                                                margin="normal"
                                                helperText={this.state.facebookUrlError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.facebookUrl}
                                                onChange={(e) => this.HandleFacebookUrlChange(e)}
                                                variant="outlined"
                                                disabled={false}
                                            />
                                        </Grid>
                                        <Grid item sm={6}>
                                            <TextField
                                                error={this.state.twitterUrlError !== ""}
                                                fullWidth
                                                id="twitterUrl"
                                                type="text"
                                                label="X (Twitter)"
                                                placeholder="X (Twitter)"
                                                margin="normal"
                                                helperText={this.state.twitterUrlError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.twitterUrl}
                                                onChange={(e) => this.HandleTwitterUrlChange(e)}
                                                variant="outlined"
                                                disabled={false}
                                            />
                                        </Grid>
                                        <Grid item sm={6}>
                                            <TextField
                                                error={this.state.instagramUrlError !== ""}
                                                fullWidth
                                                id="instagramUrl"
                                                type="text"
                                                label="Instagram"
                                                placeholder="Instagram"
                                                margin="normal"
                                                helperText={this.state.instagramUrlError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.instagramUrl}
                                                onChange={(e) => this.HandleInstagramUrlChange(e)}
                                                variant="outlined"
                                                disabled={false}
                                            />
                                        </Grid>
                                        <Grid item sm={6}>
                                            <TextField
                                                error={this.state.tikTokUrlError !== ""}
                                                fullWidth
                                                id="tikTokUrl"
                                                type="text"
                                                label="TikTok"
                                                placeholder="TikTok"
                                                margin="normal"
                                                helperText={this.state.tikTokUrlError}
                                                FormHelperTextProps={{
                                                    color: "red",
                                                }}
                                                value={this.state.tikTokUrl}
                                                onChange={(e) => this.HandleTikTokUrlChange(e)}
                                                variant="outlined"
                                                disabled={false}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="h6" style={{ marginTop: '10px' }}>Additional Links</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={5}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                label="Link Name"
                                                placeholder="e.g. Website, Portfolio"
                                                value={this.state.newLinkName}
                                                onChange={this.HandleNewLinkNameChange}
                                                error={!!this.state.newLinkNameError}
                                                helperText={this.state.newLinkNameError}
                                                variant="outlined"
                                                margin="normal"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={5}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                label="Link URL"
                                                placeholder="https://example.com"
                                                value={this.state.newLinkUrl}
                                                onChange={this.HandleNewLinkUrlChange}
                                                error={!!this.state.newLinkUrlError}
                                                helperText={this.state.newLinkUrlError}
                                                variant="outlined"
                                                margin="normal"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2} style={{ display: 'flex', alignItems: 'center', marginTop: '4px', height: '84px' }}>
                                            <Button 
                                                variant="contained" 
                                                className='btn-primary' 
                                                onClick={this.HandleAddLink}
                                                style={{ height: '40px' }}
                                            >
                                                Add
                                            </Button>
                                        </Grid>

                                        {this.state.additionalLinks.length > 0 && (
                                            <Grid item xs={12}>
                                                <Paper variant="outlined" style={{ marginTop: '10px', maxWidth: '600px' }}>
                                                    <List dense>
                                                        {this.state.additionalLinks.map((link, index) => {
                                                            let href = link.url;
                                                            if (!href.match(/^https?:\/\//i)) {
                                                                href = 'https://' + href;
                                                            }
                                                            return (
                                                            <ListItem key={index} divider={index !== this.state.additionalLinks.length - 1}>
                                                                <ListItemText
                                                                    primary={link.name || "Link"}
                                                                    secondary={
                                                                        <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
                                                                            {link.url}
                                                                        </a>
                                                                    }
                                                                />
                                                                <ListItemSecondaryAction>
                                                                    <IconButton 
                                                                        edge="end" 
                                                                        aria-label="delete"
                                                                        onClick={() => this.HandleRemoveLink(index)}
                                                                        title="Remove link"
                                                                        size="small"
                                                                    >
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        )})}
                                                    </List>
                                                </Paper>
                                            </Grid>
                                        )}

                                        <Grid item xs={12}>
                                            <Typography>Summary</Typography>
                                            {!this.state.loading && (
                                                <MarkdownEditor
                                                    value={this.state.summary}
                                                    onChange={(value) => this.HandleSummaryChange(value)}
                                                ></MarkdownEditor>
                                            )}
                                        </Grid>
                                        

                                        <Grid item xs={12}>
                                            <div>
                                                <br/>
                                                <Typography>Upload Masthead Image</Typography>
                                                <div>
                                                    <i>
                                                        For best results use an image that is a rectangle with a greater width than height.
                                                        A 3:2 aspect ratio and at least 200 pixels across is ideal.
                                                    </i>
                                                </div>
                                                <br />
                                                {!this.state.mastheadImageUrl && (
                                                    <ImageUploading
                                                        value={this.state.uploadFiles}
                                                        onChange={(files: ImageListType) => this.OnAddFiles(files)}
                                                        maxNumber={1}
                                                    >
                                                        {({
                                                            imageList,
                                                            onImageUpload,
                                                            onImageRemoveAll,
                                                            onImageUpdate,
                                                            onImageRemove,
                                                            isDragging,
                                                            dragProps,
                                                        }) => (
                                                            // write your building UI
                                                            <div className="upload__image-wrapper">
                                                                {imageList.length == 0 && (
                                                                    <button
                                                                        style={
                                                                            isDragging
                                                                                ? {
                                                                                      color: "red",
                                                                                      border: "0.5px solid red",
                                                                                      width: "100%",
                                                                                      height: "200px",
                                                                                      backgroundColor: "white",
                                                                                      cursor: "pointer",
                                                                                  }
                                                                                : {
                                                                                      color: "blue",
                                                                                      border: "0.5px solid blue",
                                                                                      width: "100%",
                                                                                      height: "200px",
                                                                                      backgroundColor: "white",
                                                                                      cursor: "pointer",
                                                                                  }
                                                                        }
                                                                        onClick={onImageUpload}
                                                                        type="button"
                                                                        {...dragProps}
                                                                    >
                                                                        Click or drop image here
                                                                    </button>
                                                                )}
                                                                {imageList.map((image, index) => (
                                                                    <div key={index} className="image-item">
                                                                        <div
                                                                            className="image-item__btn-wrapper"
                                                                            style={{ paddingBottom: "20px" }}
                                                                        >
                                                                            <Button
                                                                                onClick={() => onImageUpdate(index)}
                                                                                style={{
                                                                                    marginRight: "20px",
                                                                                    width: "200px",
                                                                                    height: "50px",
                                                                                }}
                                                                                className="btn-secondary"
                                                                            >
                                                                                Click to replace image
                                                                            </Button>
                                                                        </div>
                                                                        <div>
                                                                            {image?.file != undefined ? image.file.name : ""}{" "}
                                                                            {this.GetImageFileSize(image?.file!.size ?? 0)}
                                                                        </div>
                                                                        <img
                                                                            src={image?.dataURL}
                                                                            alt={"image preview"}
                                                                            style={{ width: 200, margin: 10 }}
                                                                        />
                                                                        <div style={{ width: "200px", textAlign: "center" }}>
                                                                            <button
                                                                                onClick={() => onImageRemove(index)}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <ClearIcon />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </ImageUploading>
                                                )}
                                                {this.state.mastheadImageUrl && (
                                                    <div style={{ width: "100%" }}>
                                                        
                                                            <span style={{ width: "200px" }}>
                                                                <div>
                                                                    <img
                                                                        src={this.state.mastheadImageUrl}
                                                                        alt="image preview"
                                                                        style={{ width: 200, margin: 10 }}
                                                                    />
                                                                </div>
                                                                <div style={{ width: "200px", textAlign: "center" }}>
                                                                    <button
                                                                        onClick={() => this.RemoveSavedFile()}
                                                                        title={`Remove Masthead Image`}
                                                                    >
                                                                        <ClearIcon />
                                                                    </button>
                                                                </div>
                                                            </span>
                                                        
                                                    </div>
                                                )}
                                            </div>
                                        </Grid>
                                    </React.Fragment>
                                )}
                            </Grid>
                        </CardContent>
                        <CardContent>
                            <CardActions>
                                <Button
                                    variant="contained"
                                    size="large"
                                    className="btn-primary"
                                    onClick={createOrganization ? this.OpenCreateConfirmModal : this.HandleSaveOrganization}
                                >
                                    {createOrganization && <span>Create Organization </span>}
                                    {createOrganization == false && <span>Update Organization </span>}
                                </Button>
                            </CardActions>
                        </CardContent>
                    </Card>
                    <GenericErrorModal
                        hidden={this.state.serverError == ""}
                        message={this.state.serverError}
                        closeModal={this.CloseErrorModal}
                    />

                    <Dialog
                        onClose={this.CloseCreateModal}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        title="Create Organization - WARNING"
                        open={this.state.createConfirmModalOpen}
                    >
                        <DialogTitle disableTypography className="dialog-title-warning">
                            <Typography variant="h6">Add Zip Code Sales Tax</Typography>
                            <IconButton aria-label="close" className="close-button" onClick={this.CloseCreateModal}>
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            The following fields are no longer editable after you save. Any changes to these fields will require that you
                            create a new organization.
                            <ul>
                                <li>Account Type</li>
                                <li>Email</li>
                                <li>Phone</li>
                                <li>First Name</li>
                                <li>Last Name</li>
                                <li>Birthday</li>
                                <li>Street Address</li>
                                <li>City</li>
                                <li>State</li>
                                <li>Zip code</li>
                            </ul>
                            <div>
                                <h2>IRS Reporting Form 1099-K</h2>
                                <p>
                                    The following form is required by the U.S. Internal Revenue Service and is only available in U.S.
                                    English. Please complete in U.S. English. If you need help,&nbsp;
                                    <Link target="_blank" href="https://www.irs.gov/businesses/understanding-your-form-1099-k">
                                        view IRS 1099-K Details.
                                    </Link>
                                </p>
                                <p>Under the penalties of perjury, I hereby certify that:</p>
                                <ol>
                                    <li>
                                        The number shown on this form is my true and accurate taxpayer identification number (or I am
                                        otherwise waiting for a number to be issued to me); and
                                    </li>
                                    <li>
                                        I am not subject to backup withholding because:
                                        <ul>
                                            <li>(a) I am exempt from backup withholding, or </li>
                                            <li>
                                                (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to
                                                backup withholding as a result of a failure to report all interest or dividends, or
                                            </li>
                                            <li>(c) the IRS has notified me that I am no longer subject to backup withholding; and</li>
                                        </ul>
                                    </li>
                                    <li>I am a U.S. citizen or other valid U.S. person; and</li>
                                    <li>
                                        The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is
                                        correct.
                                    </li>
                                </ol>
                                <p>
                                    The Internal Revenue Service does not require your consent to any of the provisions of this document
                                    other than the certifications required to avoid backup withholding of funds.
                                </p>
                                <TextField
                                    error={this.state.taxFormSignatureError !== ""}
                                    fullWidth
                                    id="taxFormSignature"
                                    type="text"
                                    label={"Typing your full name acts as your signature: " + this.state.taxFormSignatureExpected}
                                    placeholder="Signature"
                                    margin="normal"
                                    helperText={this.state.taxFormSignatureError}
                                    FormHelperTextProps={{ color: "red" }}
                                    value={this.state.taxFormSignature}
                                    onChange={(e) => this.HandleTaxFormSignatureChange(e)}
                                    variant="outlined"
                                    disabled={createOrganization == false}
                                />
                                <p>Sign date: {this.state.taxFormSignedAt.toDateString()}</p>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.CloseCreateModal} className="two-action-buttons">
                                Cancel
                            </Button>
                            <Button
                                onClick={this.HandleSaveOrganization}
                                className="two-action-buttons"
                                disabled={this.state.taxFormSignatureError != "" || this.state.taxFormSignature == ""}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        );
    }
}
